import React                        from 'react';
import { Label, Popup, PopupProps } from 'semantic-ui-react';
import { FinePrintMessage }         from '@src/views/components/util/messaging/FinePrintMessage';


interface DefaultProjectVersionLabelProps {
    showPopup?: boolean,
    popupProps?: PopupProps,
}

const DefaultProjectVersionLabelDefaultProps = {
    showPopup:  true,
    popupProps: {},
} satisfies Partial<DefaultProjectVersionLabelProps>;

function DefaultProjectVersionLabel( _props: DefaultProjectVersionLabelProps ){

    const props = { ...DefaultProjectVersionLabelDefaultProps, ..._props };

    return (
        <Popup
            disabled={ !props.showPopup }
            trigger={ <Label className={ 'cursor--default' } circular size={ 'tiny' } color={ 'black' }>Default</Label> }
            { ...props.popupProps }>

            <FinePrintMessage>This is the initial version of this project.</FinePrintMessage>

        </Popup>
    );
}

export {
    DefaultProjectVersionLabel,
    DefaultProjectVersionLabelDefaultProps,
    type DefaultProjectVersionLabelProps,
};
